"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommandingClient = void 0;

var _response_pb = require("../proto/spine/core/response_pb");

var _commandRequest = require("./command-request");

var _errors = require("./errors");

var _objectToProto = _interopRequireDefault(require("./object-to-proto"));

var _typedMessage = require("./typed-message");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var _statusType = _response_pb.Status.typeUrl();
/**
 * A client which posts commands.
 *
 * This class has a default implementation but is intended to be overridden as necessary if it's
 * required to change the behavior.
 */


var CommandingClient = /*#__PURE__*/function () {
  function CommandingClient(endpoint, requestFactory) {
    _classCallCheck(this, CommandingClient);

    this._requestFactory = requestFactory;
    this._endpoint = endpoint;
  }
  /**
   * Creates a new command request.
   *
   * @param {!Message} commandMessage the command to send to the server
   * @param {!Client} client the client which initiated the request
   * @return {CommandRequest} a new command request
   */


  _createClass(CommandingClient, [{
    key: "command",
    value: function command(commandMessage, client) {
      return new _commandRequest.CommandRequest(commandMessage, client, this._requestFactory);
    }
    /**
     * Posts a given command to the Spine server.
     *
     * @param {!spine.core.Command} command a Command sent to Spine server
     * @param {!AckCallback} onAck a command acknowledgement callback
     */

  }, {
    key: "post",
    value: function post(command, onAck) {
      var _this = this;

      var cmd = _typedMessage.TypedMessage.of(command);

      this._endpoint.command(cmd).then(function (ack) {
        return _this._onAck(ack, onAck);
      })["catch"](function (error) {
        onAck.onError(new _errors.CommandHandlingError(error.message, error));
      });
    }
  }, {
    key: "_onAck",
    value: function _onAck(ack, onAck) {
      var responseStatus = ack.status;

      var responseStatusProto = _objectToProto["default"].convert(responseStatus, _statusType);

      var responseStatusCase = responseStatusProto.getStatusCase();

      switch (responseStatusCase) {
        case _response_pb.Status.StatusCase.OK:
          onAck.onOk();
          break;

        case _response_pb.Status.StatusCase.ERROR:
          var error = responseStatusProto.getError();
          var message = error.getMessage();
          onAck.onError(error.hasValidationError() ? new _errors.CommandValidationError(message, error) : new _errors.CommandHandlingError(message, error));
          break;

        case _response_pb.Status.StatusCase.REJECTION:
          onAck.onImmediateRejection(responseStatusProto.getRejection());
          break;

        default:
          onAck.onError(new _errors.SpineError("Unknown response status case ".concat(responseStatusCase)));
      }
    }
  }]);

  return CommandingClient;
}();

exports.CommandingClient = CommandingClient;
//# sourceMappingURL=commanding-client.js.map